import CartNotification from "@surf-turf/nemo/assets/utils-cart-notification-state";
import { getCartSectionsToRender } from "../utils/get-sections.js";
import { getSectionFromHTML } from "@surf-turf/nemo/assets/utils-section-injection";
import { initDraggableSliders } from "./draggable-sliders";
import { CartItem } from "../extenders/cart-item";
import { handleGoodieListenersCheckbox } from "../extenders/selected-goodies.js";

/**
 * Handle add to cart notification.
 *
 * @param responseData {object}
 */
const handleChangeCart = (responseData) => {
  // Get sections to render and set them in the html.
  getCartSectionsToRender().forEach((section) => {
    if (section.id === "cart-notification-product") {
      const productId = responseData.id;

      if (productId) {
        getCartSectionsToRender(productId).forEach((section) => {
          const sectionElement = document.getElementById(section.id);

          if (sectionElement != null) {
            sectionElement.innerHTML = getSectionFromHTML(
              responseData.sections[section.id],
              section.selector
            );
          }
        });
      }
    } else if (section.id === "cart-drawer") {
      const drawerElement = new DOMParser().parseFromString(
        responseData.sections["cart-drawer"],
        "text/html"
      );
      const drawerElementsToRender = [
        {
          selector: "#cart-promo-meter",
        },
        {
          selector: "#cart-items",
        },
        {
          selector: "#cart-gifts",
        },
        {
          selector: "#cart-totals__lines",
        },
        {
          selector: "#card-shipping",
        },
        {
          selector: "#checkout-button",
        },
        {
          selector: "#cart-usp",
        },
      ];

      if (drawerElementsToRender !== null) {
        drawerElementsToRender.map((element) => {
          const html = drawerElement.querySelector(element.selector)?.innerHTML;

          if (html) {
            document.querySelector(element.selector).innerHTML = html;
          }
        });
        handleGoodieListenersCheckbox();
        // handleGoodieBelowSingleThreshold();
      }
    } else {
      const elementToReplace =
        document.querySelectorAll(section.selector) ||
        document.getElementById(section.id).querySelector(section.selector);

      if (elementToReplace !== null) {
        elementToReplace.forEach((element) => {
          element.innerHTML = getSectionFromHTML(
            responseData.sections[section.section],
            section.selector
          );
        });

        // Check if element is defined, if not define it..
        if (customElements.get("cart-item") === undefined) {
          customElements.define("cart-item", CartItem);
        }
      }
    }

    // attach event listeners to the new elements.
    initDraggableSliders();
  });
};

export { handleChangeCart };
